import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const deleteMsgConfModalSelector = createSelector(modalsSelector, (modals) => modals.deleteMessageConf);

export default deleteMsgConfModalSelector;
